import { useActiveCompany, type ActiveCompanyValue } from './active-company-context';

// Empresa del documento frente a la activa (hallazgos H4/H7 del 2026-10-14). Un actor
// cross-company ve fichas de cualquier empresa, pero la capacitación y los reprocesos se
// consultan bajo la empresa activa: si no coinciden, la tarjeta lo explica en vez de
// afirmar que no hay datos.

export type DocumentCompanyAccess =
  | { kind: 'active' }
  | { kind: 'no-active' }
  /** `name` es null si la empresa no está entre las del usuario (no puede cambiar a ella). */
  | { kind: 'other'; companyId: string; name: string | null };

export function documentCompanyAccess(
  companyId: string,
  active: Pick<ActiveCompanyValue, 'activeCompanyId' | 'companies'>,
): DocumentCompanyAccess {
  if (active.activeCompanyId === null) {
    return { kind: 'no-active' };
  }
  if (active.activeCompanyId === companyId) {
    return { kind: 'active' };
  }
  const name = active.companies.find((c) => c.id === companyId)?.name ?? null;
  return { kind: 'other', companyId, name };
}

export function useDocumentCompanyAccess(companyId: string): DocumentCompanyAccess {
  return documentCompanyAccess(companyId, useActiveCompany());
}
